
import React from 'react';
import YourStripesComponent from '../components/YourStripesComponent';
import RecentStripesComponent from '../components/RecentStripesComponent';

const GalleryPage = () => {

    return (
        <div className="mainContent">
            <YourStripesComponent />
            <RecentStripesComponent />
        </div>
    );
}

export default GalleryPage;